import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const raw = localStorage.getItem('zocs_auth');
  const token = raw ? JSON.parse(raw).token : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function getMarketerDashboard({ period = 'last_10_days', sort = 'orders', dateFrom, dateTo } = {}) {
  const params = { period, sort };
  if (period === 'custom') { params.date_from = dateFrom; params.date_to = dateTo; }
  const res = await axios.get(`${API_BASE}/marketer/dashboard`, { headers: authHeader(), params });
  return res.data;
}

export async function getMarketerLocations({ period = 'last_10_days', sort = 'orders', dateFrom, dateTo } = {}) {
  const params = { period, sort };
  if (period === 'custom') { params.date_from = dateFrom; params.date_to = dateTo; }
  const res = await axios.get(`${API_BASE}/marketer/locations`, { headers: authHeader(), params });
  return res.data;
}
